import React from 'react';
import {Button} from "primereact/button";
import {useDispatch, useSelector} from "react-redux";
import {selectYear} from "../../redux/slices/kpiSlice";

const YearSelector = () => {
    const selectedYear = useSelector(state => state.kpi.selectedYear);
    const dispatch = useDispatch();

    const changeSelectedYear = (diff) => dispatch(selectYear(selectedYear + diff));
    const currentYear = new Date().getFullYear();

    return (
        <div className="year-selector">
            <Button type="button" icon="pi pi-chevron-left" onClick={() => changeSelectedYear(-1)} />
            <div className="current-year">{selectedYear}</div>
            <Button type="button" icon="pi pi-chevron-right" onClick={() => changeSelectedYear(1)} />
        </div>
    )
}

export default YearSelector;